// 导入axios接口
import axiosRequest from '@/utils/axios-default-request';

// 查询职位管理列表信息
let  getPositionProjectList= (data) =>axiosRequest.postBodyJson('/clientinterface/getPositionProjectList',data);

// 查询简历投递页面
let  getResumeDeliveryList= (data) =>axiosRequest.postBody('/clientinterface/getResumeDelivery',data);

// 获取申请项目类型
let  getProjectTypeData= (data) =>axiosRequest.postBody('/supinterface/getProjectTypeData',data);

// 获取项目状态 /supinterface/getTaskStateData
let  getTaskStateData= (data) =>axiosRequest.postBody('/supinterface/getTaskStateData',data);

// 获取项目状态 /supinterface/getBankStateData
let  getBankStateData= (data) =>axiosRequest.postBody('/supinterface/getBankStateData',data);

// 删除职位
let  deletePositionProject= (data) =>axiosRequest.postBody('/clientinterface/deletePositionProject',data);

// 添加职位
let  addPositionProject= (data) =>axiosRequest.postBodyJson('/clientinterface/addPositionProject',data);

// 修改职位
let  editPositionProject= (data) =>axiosRequest.postBodyJson('/clientinterface/editPositionProject',data);

// 岗位详情 
let  detailPositionProject= (data) =>axiosRequest.postBody('/clientinterface/detailPositionProject',data);

// 根据项目id 获取简历投递数据 getPositionProjectResume
let  getPositionProjectResume= (data) =>axiosRequest.postBody('/clientinterface/getPositionProjectResume',data);

// 简历收藏状态修改（0 未收藏，1 已收藏 ） setJlIsCollect
let  setJlIsCollect= (data) =>axiosRequest.postBody('/clientinterface/setJlIsCollect',data);

// 简历匹配状态修改
let  setJlMatchingStatus= (data) =>axiosRequest.postBody('/clientinterface/setJlMatchingStatus',data);

// 简历阅读状态修改（0 未阅读，1 已阅读 ）
// let  setJlIsRead= (data) =>axiosRequest.postBody('/clientinterface/setJlIsRead',data);

// 查询人才评价列表信息
let  getSupEvaluateList= (data) =>axiosRequest.postBodyJson('/clientinterface/getSupEvaluateList',data);


// 人才评价编辑
let  setSupEvaluateList= (data) =>axiosRequest.postBodyJson('/clientinterface/setSupEvaluateList',data);


// 人才评价添加
let  addSupEvaluateList= (data) =>axiosRequest.postBodyJson('/clientinterface/addSupEvaluateList',data);

// 获取人才管理信息  readingStatus 0全部、1已读、2未读、3收藏
let  getProjectApplicationJlData= (data) =>axiosRequest.postBody('/clientinterface/getProjectApplicationJlData',data);

// 获取人才管理页面当前译员的项目投递信息
//   sysUserId客户端id  supUserId译员id pageSize pageNum
let getApplicationJLData = (data) => axiosRequest.postBody('/clientinterface/getApplicationJLData',data)



// 获取分享链接     projectReleaseInforId  项目id
let getProjectShareLink = (data) =>axiosRequest.postBody('/clientinterface/getProjectShareLink',data)


export default{
    getProjectShareLink,//获取分享链接

    getResumeDeliveryList,//查询简历投递页面
    getPositionProjectList,//查询职位管理页面
    deletePositionProject,//删除职位
    addPositionProject,//添加职位
    editPositionProject,//修改岗位
    detailPositionProject,//岗位详情
    getPositionProjectResume,//根据项目id 获取简历投递数据
    setJlIsCollect,//简历收藏状态修改（0 未收藏，1 已收藏 ）
    setJlMatchingStatus,//简历匹配状态
    // setJlIsRead,//简历阅读状态修改（0 未阅读，1 已阅读 ）
    getSupEvaluateList,//查询人才评价列表信息
    setSupEvaluateList,//人才评价编辑
    addSupEvaluateList,//人才评价添加
    getProjectTypeData,//获取申请项目类型
    getTaskStateData,//获取项目状态
    getBankStateData,//获取银行
    getProjectApplicationJlData,//获取人才管理信息  readingStatus 0全部、1已读、2未读、3收藏

    getApplicationJLData,// 获取人才管理译员信息
}